import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Lenovo from '../views/Lenovo.vue'
import Huawei from '../views/Huawei.vue'
import Vivo from '../views/Vivo.vue'
import Oppo from '../views/Oppo.vue'
import Mi from '../views/Mi.vue'
import Samsung from '../views/Samsung.vue'
import Oneplus from '../views/Oneplus.vue'
import Meizu from '../views/Meizu.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/lenovo',
    name: 'Lenovo',
    component: Lenovo
  },
  {
    path: '/huawei',
    name: 'Huawei',
    component: Huawei
  },
  {
    path: '/vivo',
    name: 'Vivo',
    component: Vivo
  },
  {
    path: '/oppo',
    name: 'Oppo',
    component: Oppo
  },
  {
    path: '/Mi',
    name: 'Mi',
    component: Mi
  },
  {
    path: '/Samsung',
    name: 'Samsung',
    component: Samsung
  },
  {
    path: '/OnePlus',
    name: 'Oneplus',
    component: Oneplus
  },
  {
    path: '/Meizu',
    name: 'Meizu',
    component: Meizu
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
